import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import OpeningMomentsModal from '../scheduling_window/OpeningMomentsModal';
import { OpenPeriod } from '../scheduling_window/types';

interface OpeningPeriodsButtonProps {
  periods: OpenPeriod[];
  windowName: string;
  disabled?: boolean;
  timezone?: string;
}

const OpeningPeriodsButton: React.FC<OpeningPeriodsButtonProps> = ({ periods, windowName, disabled = false, timezone }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button variant="outline-secondary" size="sm" disabled={disabled} onClick={() => setShowModal(true)} title="View open periods">
        <FontAwesomeIcon icon={faInfoCircle} />
      </Button>

      {showModal && (
        <OpeningMomentsModal
          show={showModal}
          onHide={() => setShowModal(false)}
          periods={periods}
          isLoading={false}
          error={null}
          windowName={windowName}
          timezone={timezone}
        />
      )}
    </>
  );
};

export default OpeningPeriodsButton;
